import React, { useCallback } from "react";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";

import * as Styled from "./styles";

interface DashboardIconProps {
  icon: string;
  title: string;
  link: string;
}

const DashboardMenuItem: React.FC<DashboardIconProps> = ({
  icon,
  title,
  link
}) => {
  const navigate = useNavigate();

  const handleNavigate = useCallback(() => {
    navigate(link);
  }, [navigate, link]);

  return (
    <Styled.Container onClick={handleNavigate}>
      <Styled.IconContainer>
        <ReactSVG src={icon} alt={title} />
      </Styled.IconContainer>
      <Styled.LabelContainer>{title}</Styled.LabelContainer>
    </Styled.Container>
  );
};

export default DashboardMenuItem;
